// §4 esbuild (@angular/build) migration: the webpack-only `__webpack_public_path__` runtime
// override was removed here. It assigned the CDN/asset base for webpack's lazy-chunk loader; in
// esbuild's strict-ESM output that global is undeclared, so the assignment would ReferenceError at
// module eval (blank app). Native dynamic import() resolves lazy chunks relative to main.js's own
// URL (= /dist/v2-hybrid/ via <base href>), so no runtime public-path is needed. Prod lazy chunks
// now serve from the app domain instead of the CDN edge — gate-invisible, matching the other apps.

// WS5 #10 Stage B B5(e): load the native-needed window-global vendors (js-beautify, Dropzone)
// FIRST — before app.module evaluates and before any native component reads
// window.js_beautify/window.css_beautify/window.Dropzone. This is the FIRST import so its side
// effects run before everything else. Survives the B6 boot-stop.
import './app/vendor-globals';
import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UIRouter, UrlService } from '@uirouter/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
if (environment.production) {
  enableProdMode();
}

// kill old sessions
if (!!localStorage.getItem("flipto.user") || !!localStorage.getItem("flipto.impersonate")) {
  ["flipto.session", "flipto.impersonate", "flipto.user", "flipto.impersonateToken", "flipto.token"]
    .forEach(key => localStorage.removeItem(key));
}

if (!!sessionStorage.getItem('flipto.session')) {
  sessionStorage.removeItem('flipto.session');
}

const app = document.createElement('ft-account-app');
document.body.appendChild(app);

// WS5 #10 Stage B B5(d): the feature-load gate (getFeaturesAsync + $ocLazyLoad loop +
// $ngRedux.replaceReducer) was a proven no-op — every feature list (group/coop/
// collaborative.features.ts) is `[]`, the v1 ng-redux store is write-only (the native
// cooperative facade sources NgRx directly), and `loadAccountFeatures` had zero callers.
// Removed here so native bootstrap no longer reaches AngularJS via `$ocLazyLoad`/`$ngRedux`.
// The `setTimeout(() => startUIRouter())` inside `NgZone.run` is bootstrap-timing-critical
// (it defers urlService.listen()/sync() past deferIntercept) — PRESERVED verbatim.
platformBrowserDynamic().bootstrapModule(AppModule)
  .then(async (platformRef) => {
    // Intialize the Angular Module
    // get() the UIRouter instance from DI to initialize the router
    const router = platformRef.injector.get(UIRouter);
    const urlService: UrlService = router.urlService;

    // Instruct UIRouter to listen to URL changes
    function startUIRouter() {
      urlService.listen();
      urlService.sync();
    }

    platformRef.injector.get(NgZone).run(() => {
      setTimeout(() => startUIRouter());
    });
  })
  .catch(err => {
    console.error(err);
  });
